import React, { Fragment, useEffect, useRef } from "react";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from '@material-ui/styles';
import { Button, Grid, Typography } from '@material-ui/core';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import { getImageMapData } from "../../../../store/global/selectors";
import ImageAreaSelector from "./ImageAreaSelector.js";
import { getDetailsFromUrl } from "../../../../services/blueprint";
import { setImageMapData, invokeGetService, triggerTour } from '../../../../store/global/actions';
import { displayAsset } from '../../../../store/assets/actions';
import { findSelectedSchema } from "../../../../services/builder/util";
import LoaderWithProgress from '../../../atoms/loader/LoaderWithProgress.js';


const useStyles = makeStyles((theme) => ({

    imageSelector: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },
    importBtn: {
        backgroundColor: '#E8E8E8',
        borderRadius: '0px',
        padding: '16px 48px',
        marginTop: '6px',
        textTransform: 'none',
        fontSize: '1rem',
        "&:focus": {
            outline: "none",
        },
        "&.Mui-focusVisible": {
            boxShadow: "none",
            border: "none",
        },
    }
}));

const ImageSelector = ({ setOpenAssetsExplorer, drawerBodyRef, isFetching, setIsFetching }) => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const [imageURL, setImageURL] = useState(null);

    const { asset, open, id } = useSelector(getImageMapData);


    const { entityId, slug } = getDetailsFromUrl();

    const prevAssetRef = useRef(asset);

    useEffect(() => {
        if (asset === undefined && id) {
            getImageMapdetails()
        }
    }, [open]);

    useEffect(() => {
        // For edit image map ui widget
        const assetChanged = prevAssetRef.current !== asset;
        if (asset && id !== undefined) {
            fetchImageDetails();
        }
        // For create image map ui widget
        if (asset && id === undefined) {
            fetchImageDetails();
        }
    }, [asset]);


    const fetchImageDetails = () => {
        setIsFetching(true);
        displayAsset(asset, slug).then((resp) => {
            if (resp.status === true) {
                setImageURL(resp.filePath);
                dispatch(setImageMapData({ url: resp.url }));
            } else {
                dispatch(setImageMapData({ areas: null }))
                setImageURL('DELETED');
            }
            setIsFetching(false);
        });
    }


    const getImageMapdetails = () => {
        if (id) {
            setIsFetching(true);
            dispatch(invokeGetService('getView', [entityId])).then(response => {
                if (response.status == true) {
                    const schemas = response.view?.view_schema;
                    const selectedMap = findSelectedSchema({ schemas, id: id })
                    if (selectedMap) {
                        const asset = selectedMap.asset;
                        const areas = selectedMap.children?.[1].default;
                        if (asset) {
                            dispatch(setImageMapData({ asset, areas }))
                        } else {
                            setIsFetching(false);
                        }
                    } else {
                        setIsFetching(false);
                    }
                } else {
                    setIsFetching(false);
                }
            });
        }
    }

    const onClickImportBtn = () => {
        setOpenAssetsExplorer(true);
    }

    // useEffect(() => {
    //     dispatch(triggerTour({currentTour: "imageMapEditor"}))
    // },[asset])

    return (
        <Fragment>
            <Grid item xs={12} className={classes.imageSelector}>
                {isFetching ? <LoaderWithProgress size={20} isContent={true} styleRoot={{ marginTop: 'calc((100vh - 800px)/2)' }} />
                    :
                    (asset === undefined) ?
                        <>
                            <Typography variant="h6" >
                                No image selected
                            </Typography>
                            <Button data-ui-tour-id="import-image-btn" variant="contained" onClick={onClickImportBtn} className={classes.importBtn} startIcon={<SystemUpdateAltIcon style={{ marginRight: 6 }} />}>
                                Import image
                            </Button>
                        </>
                        :

                        <ImageAreaSelector imageURL={imageURL} setOpenAssetsExplorer={setOpenAssetsExplorer} drawerBodyRef={drawerBodyRef} />
                }
            </Grid>
        </Fragment>

    );
};

export default ImageSelector;


